module.exports = "https://bin.bnbstatic.com/_next/static/images/Seungjae Andrew Kang-03ed2553658500912e02a1bf20a10710.jpg";